import React, { useEffect, useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep, forEach } from 'lodash-es';
import i18next from 'i18next';
import CLabel from '../../../../../Common/CLabel';
import { isNullUndefined, showMessage } from '../../../../../../common/Helpers';
import JqxProgressBar from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxprogressbar';
import { __onGoToBoardKpiOperational } from '../../../../../../common/SystemRedirections';
import { action_setCompareContracts_ChartData, action_setCompareContracts_PanelSegmentValuesSelected, action_setCompareContracts_SegmentList, action_setCompareContracts_SegmentSelected } from '../../../../../../reducers/actions/KPI/compareContractsActions';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import { Checkbox, TextField } from '@fluentui/react';
import { _global_buttonStyles } from '../../../../../../common/ObjectStructures/Trasnversal';

const SidePanelSetSegments = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { 
        _contratosParaGrafico: selectedContracts,
        _contratosBase: contratosBase,
        _segmentList: segmentList,
        _pilarSeleccionado: pilarSeleccionado,
        _chartDataBase: chartDataBase,
        _chartData: chartData,
        _segmentSelected: segmentSelected,
        _panelSegmentValues: panelSegmentValues,
        _chartDataBaseStructure: chartDataBaseStructure,
    } = useSelector((state) => state.compareContractsScope);

    const inputParam_IsPanelOpen = props.inputParam_IsPanelOpen;
    const inputParam_SetterIsPanelOpen = props.inputParam_SetterIsPanelOpen;
    const inputParam_PropertyToSearch = props.inputParam_PropertyToSearch;

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [preliminarSegments, setPreliminarSegments] = useState({
        property: null, 
        segments: !isNullUndefined(panelSegmentValues) && !isNullUndefined(panelSegmentValues.selectedSegments) ? panelSegmentValues.selectedSegments : []
    });

    const [searchText, setSearchText] = useState('');
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const normalizeText = (value) => {
        return (value ?? '')
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton 
                            styles={_global_buttonStyles} 
                            disabled={preliminarSegments.segments.length === 0} 
                            onClick={onApplyPanelSegment}
                        >
                            {t('data-lang-btn-accept')}
                        </PrimaryButton>
                        <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
                    </Col>
                </Row>
    };

    const getContractData = (contractCode) => {
        return contratosBase.find(x => x.contractCode === contractCode);
    };

    const getContractAditionalData = (contractCode) => {
        const contract = getContractData(contractCode);
        return contract ? `${contract.contractCode} - ${contract.supplierName}` : '';
    };

    const onCardClick = (property, segment) => {
        const exists = preliminarSegments.segments.some(x => x.name === segment.name);

        if (exists) {
            const updatedSegments = preliminarSegments.segments.filter(item => item.name !== segment.name);

            setPreliminarSegments({
                property: updatedSegments.length === 0 ? null : property,
                segments: updatedSegments
            });

            showMessage(setMessageConfig, false, __MessageTypes.WARNING, '');
        } else {
            const aux_segment = cloneDeep(segment);
            aux_segment.auxTitleSegment = segmentList.find(x => x.contractProp === inputParam_PropertyToSearch).filterName;
            setPreliminarSegments({
                property: property,
                segments: [...preliminarSegments.segments, aux_segment]
            });

            showMessage(setMessageConfig, false, __MessageTypes.WARNING, '');
        }
    };

    const onApplyPanelSegment = () => {
        const aux_chartData = cloneDeep(chartData);

		const currentPilarWithVals = chartDataBaseStructure.find(x => x.id === pilarSeleccionado.scopeId);

        const setValidNames = new Set(preliminarSegments.segments.map(s => s.name));

        const contracts = contratosBase.filter(item => setValidNames.has(item[inputParam_PropertyToSearch]));
        
        const groupedItems = Object.groupBy(contracts, item => item[inputParam_PropertyToSearch]);
        const mapaValores = Object.groupBy(currentPilarWithVals.l_vals, item => item.elementId);
        const todosLosPeriodos = [...new Set(currentPilarWithVals.l_vals.map(item => item.periodId))].sort((a, b) => Number(a) - Number(b));

        const seriesPorGrupo = Object.entries(groupedItems).map(([nombreGrupo, elementos]) => {
            
            // 2. Calculamos los datos iterando estrictamente sobre la lista global de períodos
            const soloValores = todosLosPeriodos.map(periodId => {
                let sumaPeriodo = 0;
                let elementosContados = 0;

                elementos.forEach(elem => {
                    const registrosElemento = mapaValores[elem.elementId] || [];

                    const registroPeriodo = registrosElemento.find(r => r.periodId === periodId);

                    const tieneValor =
                        registroPeriodo &&
                        registroPeriodo.scopeValue !== null &&
                        registroPeriodo.scopeValue !== undefined;

                    if (tieneValor) {
                        sumaPeriodo += Number(registroPeriodo.scopeValue);
                        elementosContados += 1;
                    }
                });

                if (elementosContados === 0) {
                    return null;
                }

                const promedioCrudo = sumaPeriodo / elementosContados;

                return Math.round(promedioCrudo);
            });

            const currentContract = contracts.find(x => x.contractCode === nombreGrupo)

            return {
				name: inputParam_PropertyToSearch === 'contractCode' ? `${nombreGrupo} - ${currentContract.supplierName}` : nombreGrupo,
                data: soloValores // Mantiene el orden exacto de 'todosLosPeriodos' automáticamente
            };
        });

        const titleSegmentSerie = aux_chartData.contractSeries.filter(item => (item.name.trim().startsWith("~") && item.name.trim().endsWith("~")));

        if (segmentSelected.cardSegment === "...") {
            const mergedSeries = [...seriesPorGrupo, ...aux_chartData.contractSeries];

            aux_chartData.contractSeries = mergedSeries.filter((serie, index, self) =>
                index === self.findIndex(x => x.name === serie.name)
            );
        }
        else {
            aux_chartData.contractSeries = [...seriesPorGrupo, ...titleSegmentSerie];
        }

        dispatch(action_setCompareContracts_ChartData(aux_chartData));
        
        dispatch(action_setCompareContracts_SegmentSelected({
            titleSegment: segmentSelected.titleSegment, 
            cardSegment: '...', 
            propertySegment: inputParam_PropertyToSearch
        }));
        
        dispatch(action_setCompareContracts_PanelSegmentValuesSelected({
            titleSegment: segmentList.find(x => x.contractProp === inputParam_PropertyToSearch).filterName, 
            selectedSegments: [...preliminarSegments.segments].sort((a, b) => b.valueAux - a.valueAux)
        }));

        onDismissPanel();
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
                onRenderHeader={() => (
                    <Row className='w-100 ps-4'>
                        <Col>
                            <div style={{ fontFamily: "Segoe UI", fontSize: '20px', fontWeight: 600, color: 'rgb(50, 49, 48)', lineHeight: '27px', overflowWrap: 'break-word', wordBreak: 'break-word', hyphens: 'auto' }}>
                                <div style={{ fontSize: '20px' }}>
                                    {t('data-lang-boxname-configsegments')} {pilarSeleccionado.name}
                                </div>
                                <div style={{ fontSize: '20px', marginTop: 4 }}>
                                    {segmentList && segmentList.find(x => x.contractProp === inputParam_PropertyToSearch).filterName}
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}
            >
                <>
                    <div
                        style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 10,
                            backgroundColor: '#ffffff',
                            padding: '12px 0 10px 0',
                            borderBottom: '1px solid #edebe9'
                        }}
                    >
                        <Row>
                            <Col>
                                <TextField
                                    label="Buscar"
                                    placeholder="Buscar segmento..."
                                    value={searchText}
                                    onChange={(ev, value) => setSearchText(value || '')}
                                />
                            </Col>
                        </Row>
                    </div>
                    {
                        segmentList && segmentList.filter(x => x.contractProp === inputParam_PropertyToSearch).map((resultItem, index) => (
                            <Row key={index} className="pt-3">
                                <Col>
                                    {
                                        resultItem.l_segment_values
                                            .filter(segmentItem =>
                                                normalizeText(segmentItem.name).includes(normalizeText(searchText))
                                            )
                                            .map((segmentItem, indexItemValue) => (
                                                <Row 
                                                    key={indexItemValue} 
                                                    className='pb-4 cursor-pointer' 
                                                    style={
                                                        segmentSelected.cardSegment === segmentItem.name ? {
                                                                borderWidth: '3px',
                                                                borderColor: resultItem.color,
                                                                borderStyle: 'revert-layer',
                                                                color: '#000000',
                                                                backgroundColor:'#e3e3e3'
                                                            } : undefined
                                                        }
                                                >
                                                    <Col>
                                                        <div className='mx-0 px-0 my-auto'>
                                                            <div className='my-1 ps-0 pe-1 my-0 text-start'>
                                                                <Row>
                                                                    <Col className='col-auto me-auto p-0 m-0'>
                                                                        <IconButton 
                                                                            title={t('data-lang-lbl-kpi')} 
                                                                            styles={{root: {color: "#115e8c"}}} 
                                                                            iconProps={{iconName: "Financial"}} 
                                                                            onClick={() => __onGoToBoardKpiOperational(getContractData(segmentItem.name).elementId, 4)} 
                                                                        />
                                                                    </Col>
                                                                    <Col className='p-0 m-0 my-auto'>
                                                                        <b>
                                                                            {
                                                                                inputParam_PropertyToSearch === "contractCode" 
                                                                                    ? getContractAditionalData(segmentItem.name) 
                                                                                    : segmentItem.name
                                                                            }
                                                                        </b>
                                                                    </Col>
                                                                    <Col className='col-auto ms-auto'>
                                                                        <Checkbox 
                                                                            checked={preliminarSegments.segments.some(x => x.name === segmentItem.name)} 
                                                                            onChange={() => onCardClick(resultItem.contractProp, segmentItem)} 
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                        <div className='mx-0 px-0' style={{width: "100%"}}>
                                                            <div className='d-flex border-end border-top border-bottom'>
                                                                <div className='px-0 my-auto' style={{width: "37%"}}>
                                                                    <div style={{width: "100%"}}>
                                                                        <div className={`my-1 px-0 text-start`}>
                                                                            {segmentItem.value}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='px-0 my-auto' style={{width: "63%"}}>
                                                                    <div style={{width: "100%"}}>
                                                                        <div className={`my-1 px-0 mx-0`}>                                   
                                                                            <JqxProgressBar 
                                                                                width={'100%'} 
                                                                                height={30} 
                                                                                value={segmentItem.value} 
                                                                                className={`custom-progressbar-on`} 
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            ))
                                    }
                                </Col>
                            </Row>
                        ))
                    }
                </>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelSetSegments;